/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {
	
	jQuery('.main-search-icon a').click(function(){
		jQuery('.main-search').toggleClass('open-search');
	});

}); 